import GameManagementActionType from 'actions/gameManagement/gameManagementActionType';

const initialState = {
  games: {},
  game: {},
  gameThemes: [],
  gameGroups: null,
  gameGroup: {},
  endedStatus: false,
  csvGames: [],
  gameTypes: {},
  gameType: {},
  csvGameTypeGames: [],
  gameBadges: [],
  gameSystemGroups: [],
};

const gameManagementReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case GameManagementActionType.SAVE_GAMES:
    return {
      ...state,
      games: payload.data,
    };
  case GameManagementActionType.RESET_GAMES:
    return {
      ...state,
      games: {},
    };
  case GameManagementActionType.SAVE_GAME:
    return {
      ...state,
      game: payload.data,
    };
  case GameManagementActionType.RESET_GAME:
    return {
      ...state,
      game: {},
    };
  case GameManagementActionType.SAVE_GAME_GROUPS:
    return {
      ...state,
      gameGroups: payload.data,
    };
  case GameManagementActionType.RESET_GAME_GROUPS:
    return {
      ...state,
      gameGroups: null,
    };
  case GameManagementActionType.CHANGE_GAME_MANAGEMENT_ENDED_STATUS:
    return {
      ...state,
      endedStatus: payload.status,
    };

  case GameManagementActionType.SAVE_CSV_GAMES:
    return {
      ...state,
      csvGames: payload.data,
    };
  case GameManagementActionType.RESET_CSV_GAMES:
    return {
      ...state,
      csvGames: [],
    };
  case GameManagementActionType.SAVE_GAME_GROUP:
    return {
      ...state,
      gameGroup: payload.data,
    };
  case GameManagementActionType.RESET_GAME_GROUP:
    return {
      ...state,
      gameGroup: {},
    };
  case GameManagementActionType.SAVE_GAME_TYPES:
    return {
      ...state,
      gameTypes: payload.data,
    };
  case GameManagementActionType.RESET_GAME_TYPES:
    return {
      ...state,
      gameTypes: {},
    };
  case GameManagementActionType.SAVE_GAME_TYPE:
    return {
      ...state,
      gameType: payload.data,
    };
  case GameManagementActionType.RESET_GAME_TYPE:
    return {
      ...state,
      gameType: {},
    };
  case GameManagementActionType.SAVE_CSV_GAME_TYPE_GAMES:
    return {
      ...state,
      csvGameTypeGames: payload.data,
    };
  case GameManagementActionType.RESET_CSV_GAME_TYPE_GAMES:
    return {
      ...state,
      csvGameTypeGames: [],
    };
  case GameManagementActionType.SAVE_GAME_BADGES:
    return {
      ...state,
      gameBadges: payload.data,
    };
  case GameManagementActionType.RESET_GAME_BADGES:
    return {
      ...state,
      gameBadges: [],
    };
  case GameManagementActionType.SAVE_GAME_SYSTEM_GROUPS:
    return {
      ...state,
      gameSystemGroups: payload.data,
    };
  case GameManagementActionType.RESET_GAME_SYSTEM_GROUPS:
    return {
      ...state,
      gameSystemGroups: [],
    };
  default:
    return state;
  }
};

export default gameManagementReducer;
